const topbar = {
    docs: 'Docs',
    help: 'ช่วยเหลือ',
    /** UNTRANSLATED */
    subscription: 'Subscription',
};
export default Object.freeze(topbar);
